import React from "react";
import styles from "./card.module.css";
import CardFavoriteButton from "./card-favorite-button";
import getImageFileName from "../../functions/getImageFileName";
import { LOCALES } from "../../constants";

export default function Card({ lang, arcana, isOffImage, clickEvent, showFavorite }) {
    return (
        <div
            className={`${styles["card"]} ${isOffImage ? `${styles["off"]}` : ""}`}
            onClick={() => {
                if (clickEvent) clickEvent(arcana);
            }}
        >
            <div className={`${styles["card-image-wrapper"]}`}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/cards/${getImageFileName(arcana.name[[LOCALES.KO]])}.webp`}
                    alt={`${arcana.name}`}
                    loading="lazy"
                />
            </div>
            <div className={styles["card-header"]}>
                <span className={`${styles["rarity-badge"]} ${styles[arcana.rarity]}`}>{arcana.rarity}</span>
                <span className={styles["status"]}>
                    <img src={`${process.env.PUBLIC_URL}/images/icon/journey_status/${arcana.mainStat[[LOCALES.KO]]}.webp`} />
                </span>
            </div>
            <div className={styles["card-summary"]}>
                <h3>{arcana.name[lang]}</h3>
                <p className={styles["char-name"]}>{arcana.charName[lang]}</p>
            </div>
            {showFavorite && <CardFavoriteButton lang={lang} arcana={arcana} isOffImage={isOffImage} />}
        </div>
    );
}
